<script setup>
import { defineProps, defineEmits, ref, watch, toRef } from 'vue';
import Select from 'primevue/select';
import FloatLabel from 'primevue/floatlabel';

const props = defineProps({
    content: {
        type: String,
        required: true,
        default: ''
    },
    validation: {
        type: Array,
        default: () => []
    },
    element: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['update:content', 'changed', 'validated', 'unvalidated']);
const valueRef = ref('');
const valid = ref(true);
const invalidmessage = ref('');

const content = toRef(props, 'content');
watch(content, (newValue) => {
  valueRef.value = newValue;
});

// Extraer opciones del elemento
// Esperamos: element.options = [{ value: 'id1', label: 'Texto 1' }, ...]
const options = props.element.options || [];

// Permitir opción vacía (si allowEmpty es true, agregamos una opción null al inicio)
const allowEmpty = props.element.allowEmpty || false;

const finalOptions = allowEmpty 
  ? [{ value: '', label: '-- Sin selección --' }, ...options]
  : options;

const validateRules = () => {
  let isValid = true;
  let value = valueRef.value;

  for (const rule of props.validation) {
    const testExpression = rule.test
      .replace(/lenght/g, 'length');
    try {
      const func = new Function('value', `return ${testExpression}`);
      if (!func(value)) {
        isValid = false;
        emit('unvalidated', rule.message);
        invalidmessage.value = rule.message;
        break;
      }
    } catch (error) {
      console.error('Error evaluating validation rule:', error);
      isValid = false;
      emit('unvalidated', 'Error validating field');
      break;
    }
  }
  if (isValid) {
    valid.value = true;
    emit('validated');
  }
};

// Watch for value changes to trigger validation
watch(valueRef, (newValue, oldValue) => {
  if(newValue !== oldValue) {
    valid.value = false;
    validateRules();
    if (valid.value) {
      emit('update:content', newValue);
      emit('changed');
      invalidmessage.value = '';
    }
  }  
});

// Initialize value with content prop
valueRef.value = props.content;

</script>

<template>
  <FloatLabel variant="on" class="pb-1 pt-1">
    <Select 
      v-model="valueRef" 
      :options="finalOptions" 
      optionLabel="label" 
      optionValue="value"
      :invalid="!valid"
      class="w-full"
      size="small"
      :placeholder="allowEmpty ? 'Seleccione una opción' : ''"
    />
    <label for="select_label" class="z-1" style="text-overflow: ellipsis; white-space: nowrap;">
      {{ element.name }}
    </label>
    <div class="z-1 text-xs text-red-800 font-bold">
      {{ !valid ? invalidmessage : '' }}
    </div>
  </FloatLabel>
</template>

<style scoped>
/* Estilos específicos si son necesarios */
</style>
